import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Share = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Share' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M19,13 L19,23 L1,23 L1,5 L1,5 L11,5 M14,1 L23,1 L23,10 M10,14 L22.9999998,1 L10,14 Z' />
  </StyledIcon>
);
